import { SimulationSettings, defaultSimulationSettings, SimulationSettingEnum } from '../types/simulation';

class SimulationService {
  private static instance: SimulationService;
  private settings: SimulationSettings;

  private constructor() {
    this.settings = { ...defaultSimulationSettings };
  }

  public static getInstance(): SimulationService {
    if (!SimulationService.instance) {
      SimulationService.instance = new SimulationService();
    }
    return SimulationService.instance;
  }

  public getSettings(): SimulationSettings {
    return { ...this.settings };
  }

  public updateSettings(settings: Partial<SimulationSettings>): void {
    this.settings = {
      ...this.settings,
      ...settings
    };
  }

  public reset(): void {
    this.settings = { ...defaultSimulationSettings };
  }

  // Success Step Override Helpers
  public shouldOverrideTcpaHours(): { override: boolean; isWithin: boolean } {
    const setting = this.settings[SimulationSettingEnum.TCPA_HOURS];
    if (setting === 'auto') return { override: false, isWithin: false };
    return { override: true, isWithin: setting === 'within' };
  }

  public shouldOverrideWeekend(): { override: boolean; isWeekend: boolean } {
    const setting = this.settings[SimulationSettingEnum.WEEKEND];
    if (setting === 'auto') return { override: false, isWeekend: false };
    return { override: true, isWeekend: setting === 'weekend' };
  }

  public shouldOverrideHoliday(): { override: boolean; isHoliday: boolean } {
    const setting = this.settings[SimulationSettingEnum.HOLIDAY];
    if (setting === 'auto') return { override: false, isHoliday: false };
    return { override: true, isHoliday: setting === 'holiday' };
  }

  public shouldOverrideBpoAgent(): { override: boolean; isBpoAgent: boolean } {
    const setting = this.settings[SimulationSettingEnum.BPO_AGENT];
    if (setting === 'auto') return { override: false, isBpoAgent: false };
    return { override: true, isBpoAgent: setting === 'bpo' };
  }

  public shouldOverrideCallInitiated(): { override: boolean; isCallInitiated: boolean } {
    const setting = this.settings[SimulationSettingEnum.CALL_INITIATED];
    if (setting === 'auto') return { override: false, isCallInitiated: false };
    return { override: true, isCallInitiated: setting === 'initiated' };
  }

  public shouldOverrideScheduledTime(): { override: boolean; scheduledTime: Date | null } {
    const setting = this.settings[SimulationSettingEnum.SCHEDULED_TIME];
    if (setting === 'auto') return { override: false, scheduledTime: null };
    // Return a scheduled time 1 day in the future
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(10, 30, 0, 0); // 10:30 AM
    return { override: true, scheduledTime: tomorrow };
  }
}

export const simulationService = SimulationService.getInstance();